export const documentItemTagWrapperStyles = {
  display: 'inline-flex',
  minWidth: 0,
  maxWidth: '100%',
};

// minWidth: 0 is load-bearing: without it this flex child (of LabelCDS's inline-flex
// Typography root) refuses to shrink below its own text's natural content width, so
// when the pane narrows the whole metaRow's outer overflow:hidden hard-clips the chip
// (no ellipsis) instead of this box's own ellipsis ever engaging.
export const documentItemTagLabelStyles = {
  display: 'block',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
